import React from "react";

import TopLiveSimTakers from "../TopLiveSimTakers";
import TopLiveLosers from "../TopLiveLosers";
import { TableWrapper } from "../../styledComponents";

const TopLiveLosersAndLiveSimTakersTab: React.FC = () => (
  <div>
    <TableWrapper>
      <TopLiveSimTakers />
    </TableWrapper>
    <hr />
    <TableWrapper>
      <TopLiveLosers />
    </TableWrapper>
  </div>
);

export default TopLiveLosersAndLiveSimTakersTab;
